import request from '@/utils/request'

export function methodPost(url, params) {
  return request({
    url: url,
    method: 'post',
    data: params
  })
}
export function methodGet(url, query) {
  return request({
    url: url,
    method: 'get',
    params: query
  })
}
// 分销商渠道价格方案
export function productPriceProgramByModel(url, method, params) {
  return request({
    url: url,
    method: method,
    data: params
  })
}
// 分销渠道保存请求
export function saveDistribution(url, method, params) {
  return request({
    url: url,
    method: method,
    data: params
  })
}

// 分销渠道编辑接口请求
export function editDistribution(url, method, params) {
  return request({
    url: url,
    method: method,
    data: params
  })
}

// 分销商管理详情基本信息接口
export function findDistributerDeatil(url, method, params) {
  return request({
    url: url,
    method: method,
    params: params
  })
}

// 分销商管理详情基本信息保存
export function saveDistributerDeatil(url, method, params) {
  return request({
    url: url,
    method: method,
    data: params
  })
}

// 价格方案管理模块接口
export function postBandParams(url, method, params) {
  return request({
    url: url,
    method: method,
    data: params
  })
}

export function priceNoneParams(url, method) {
  return request({
    url: url,
    method: method
  })
}



// WEBPACK FOOTER //
// ./src/_app/outlet/src/api/request.js